import React, { useEffect, useState } from "react";
import { ChevronUp, Link } from "react-bootstrap-icons";
import { FileText } from "react-bootstrap-icons";
import { kopecks2rubStr } from "../../../common/functions";
import { MainURL, pathPrefix } from "../../../common/config/vars";
import { queryCurrChargeRents } from "../logics/rent";
import { Preloader } from "../../../common/ui/Preloader/preloader";
import IconCharge from "../../../common/assets/icons/charge.png";
import { getCustomUserAgent, getCustomUserAgentASB } from "../../../common/customUserAgent";
import { $SiteColors } from "../../../common/config/company-atts";
import { queryGetBillForm } from "../../reconciliationAct/logic/getActs";
import { $selectedAccountId } from "../../../common/accounts2";

interface IChargesListItem {
  id: string
  last: boolean;
  kopeiki: number;
  periodName: string;
  periodId: string;
  screenWidth: number;
  accountId: number;
  lookButtonIsClicked: boolean;
  setLookButtonIsClicked: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ChargesListItem = ({
  last,
  kopeiki,
  periodName,
  periodId,
  screenWidth,
  accountId,
  lookButtonIsClicked,
  id,
  setLookButtonIsClicked,
}: IChargesListItem) => {
  let summa = kopecks2rubStr(kopeiki);
  const rightPeriodName = periodName[0].toUpperCase() + periodName.slice(1);
  const [showRentTable, setShowRentTable] = useState<boolean>(false);
  const [rents, setRents] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    setRents([]);
    setShowRentTable(false);
    setLoading(false);
  }, [accountId]);

  // useEffect(() => {
  //   console.log('rents ', rents)
  // }, [rents])

  React.useEffect(() => {
    if (lookButtonIsClicked && last) {
      getRentInfo();
    }
  }, [lookButtonIsClicked]);

  const getBillButton = (services: any, date: string) => {
    const types = [
      'bill',
      'act',
      'invoice'
    ]
    services.forEach((element: { typeOfBill: any; }) => {  
      console.log(element)    
      types.forEach(type => {
        queryGetBillForm({
          accountId: $selectedAccountId.getState(),
          typeName: element.typeOfBill,
          docType: type,
          date: date
        })
      })
    })
  };

  function getRentInfo() 
  {
    if (rents.length === 0) 
    {
      setShowRentTable(true);
      setLoading(true);
      queryCurrChargeRents({ accountId, id }).then((res) => 
      {
        if(res != null) setRents(res);
        else setRents([])

        console.log('resresres Rents', res, rents)
      })
      .finally(() => setLoading(false));
    } 
    else 
    {
      setLookButtonIsClicked(false);
    }
    setShowRentTable(!showRentTable);
  }

  return (
    <li className="charges__el" id={last ? 'last-charge' : ''}>
      <div className="charges__el-header">
        <div className="charges__icon-text">
          <div className="" style={{ fontSize: "30" }}>
            <img src={IconCharge} alt="" style={{ width: "30px", height: "30px" }} />
          </div>
          <p className="charges__text charges__text_date">{rightPeriodName}</p>
        </div>
        <p className="charges__text charges__text_center">{summa}</p>
        <button className="charges__button" onClick={getRentInfo}>
          {screenWidth > 500 && (showRentTable ? "Скрыть" : "Подробнее")}
          {screenWidth <= 500 && (showRentTable ? ( <ChevronUp /> ) :
            (
              <ChevronUp
                style={{ transform: "rotateX(-180deg)",}}
              />
            ))
          }
        </button>
      </div>
      {showRentTable && (
        <div className="charges__el-bills">
          {loading && <Preloader small={false} />}
          {!loading &&
            rents.length !== 0 &&
            getCustomUserAgent() === getCustomUserAgentASB() ?
            <>
              <div className="bill">
                {rents[0].length !== 0 ?
                  <>
                    <div className="bill__header">
                      <h3 className="bill__title" style={{ width: "240px" }}>Счета на предоплату</h3>
                      <p className="bill__column-title">Кол-во</p>
                      <p className="bill__column-title">Стоимость</p>
                    </div>
                    <ul className="bill__services-list">
                      {rents[0].map((el: { services: any[]; }) => {
                        return (
                          el.services.map((li: any, i: number) => (
                            <li className="bill__service" key={i}>
                              <p className="bill__text">{li.serviceName}</p>
                              <p className="bill__text">
                                {li.volumeTotal} {li.unitName}
                              </p>
                              <p className="bill__text">{kopecks2rubStr(li.toPay)}</p>
                            </li>
                          )
                          ))
                      }
                      )}
                    </ul>
                  </>
                  : null}
                  {rents[1].length !== 0 ?
                  <>
                <div className="bill__header">
                  <h3 className="bill__title" style={{ width: "260px" }}>Счета на оплату
                    <button
                      type="button"
                      className="payment__button"
                      style={{ backgroundColor: $SiteColors.getState().backBtnSubmit, height: "25px", width: "90px", fontSize: "12px", display: "inline", marginLeft: "1rem" }}
                      onClick={() => getBillButton(rents[1], rightPeriodName)}
                    >
                      Скачать
                    </button>
                  </h3>
                  <p className="bill__column-title">Кол-во</p>
                  <p className="bill__column-title">Стоимость</p>
                </div>
                <ul className="bill__services-list">
                  {rents[1].map(((elem: { services: any[]; }) => {
                    return (
                      elem.services.map((li: any, i: number) => (
                        <li className="bill__service" key={i}>
                          <p className="bill__text">{li.serviceName}</p>
                          <p className="bill__text">
                            {li.volumePersonal} {li.unitName}
                          </p>
                          <p className="bill__text">{kopecks2rubStr(li.toPay)}</p>
                        </li>
                      ))
                    )
                  }))}
                </ul>
                </>
              :null}
                {rents[2].pdfLink.exist && (
                  <a href={`${MainURL}/${rents[2].pdfLink.pdfFile}`} target="_blank" download className="charges__link">
                    Скачать квинтацию (pdf)
                  </a>
                )}
              </div>
            </> :
            rents.map((el, i) => (
              el.services ?
                <div className="bill" key={i}>
                  {el.typeOfBill &&
                    <div className="bill__header">
                      <h3 className="bill__title">{el.typeOfBill}</h3>
                      <p className="bill__column-title">Кол-во</p>
                      <p className="bill__column-title">Стоимость</p>
                    </div>
                  }
                  <ul className="bill__services-list">
                    {el.services && el.services.map((li: any, i: number) => (
                      <li className="bill__service" key={i}>
                        <p className="bill__text">{li.serviceName}</p>
                        <p className="bill__text">
                          {li.volumeTotal} {li.unitName}
                        </p>
                        <p className="bill__text">{kopecks2rubStr(li.toPay)}</p>
                      </li>
                    ))}
                  </ul>
                  {el.pdfLink && (
                    <a href={el.pdfLink.pdfFile} 
                    target="_blank" 
                    download 
                    className="charges__link" 
                    key={i} 
                    style={{ color: $SiteColors.getState().chargeTextColor }}>
                      Скачать квинтацию (pdf)
                    </a>
                  )}
                </div>
                : null


            ))}
        </div>
      )}
    </li>
  );
};
